export const PASSWORD_ERROR_TYPES = {
  MIN: 'min',
  ONE_UPPERCASE: 'oneUppercase',
  ONE_LOWERCASE: 'oneLowercase',
  ONE_NUMBER: 'oneNumber',
  ONE_SPECIAL_CHARACTERS: 'oneSpecialCharacters',
} as const;

type IPasswordRequirementItem = {
  message: string;
};

export type IPasswordRequirements = Record<
  (typeof PASSWORD_ERROR_TYPES)[keyof typeof PASSWORD_ERROR_TYPES],
  IPasswordRequirementItem
>;
